module.exports = __webpack_public_path__ + "static/media/UserAvatar.f6c60843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/UserAvatar.png
// module id = 443
// module chunks = 0